export const getProductsTotalPrice = (products) => {
  let totalPrice = 0;

  for (let i = 0; i < products?.length; i++) {
    totalPrice += products[i]?.total;
  }

  return totalPrice;
}